var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('add-update-resource-action',{ref:"newResourceActionForm",attrs:{"updating-resource-action":_vm.resourceAction,"resource-id":_vm.resourceId},on:{"update":_vm.onUpdateResourceAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }